import React from 'react'
import { ErrorBoundary } from '@sentry/react'
import type { ErrorBoundaryProps } from '@sentry/react/dist/errorboundary'

import { isSSR } from '../../utils/env'

const SentryErrorBoundary: React.FC<ErrorBoundaryProps> = (props) => {
  // If we are building and an error happens, raise and break the build.
  // At runtime, capture the error and do fallback logic, if present.
  if (isSSR) {
    return <>{props.children}</>
  }

  return <ErrorBoundary {...props} />
}

export default SentryErrorBoundary
